import logo from '../assets/teko-blue-booking.svg';

export function Header() {
  return (
    <header className="topbar">
      <div className="inner">
        <a className="brand-wrap" href="/">
          <img src={logo} alt="Itaqueri" width={52} height={52} />
          <div>
            <div className="brand">Itaqueri</div>
            <div className="subbrand">Viva a Serra do Itaqueri</div>
          </div>
        </a>
      </div>
    </header>
  );
}
